var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{attrs:{"id":_vm.modalId,"ok-handler":_vm.okHandler,"title":_vm.title,"ok-button-text":_vm.okButtonText,"ok-button-class":_vm.okButtonClass}},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }